import classnames from 'classnames/bind'
import { useFormikContext } from 'formik'
import { useTranslation } from 'next-i18next'

// Components
import Form from '@/components/common/Form'
import Button from '@/components/common/Button'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

const PortraitReleaseAgreementPopupContentForm = (props: any) => {
  const { popupRef, checkPopupRef } = props
  const { values }: any = useFormikContext()
  const { t } = useTranslation()

  const handleClosePopup = () => {
    if (popupRef) popupRef.current?.setIsPopupOpen(false)
  }

  const handleCheckPopup = () => {
    if (checkPopupRef) checkPopupRef.current?.setIsPopupOpen(true)
  }

  const handleAgree = () => {
    handleCheckPopup()
    handleClosePopup()
  }

  return (
    <div className={cx('portrait-release-agreement-popup-content')}>
      <div className={cx('portrait-release-agreement-popup-content__content')}>
        <div className={cx('portrait-release-agreement-popup-content__agreement-text')}>{t('LiveRoom_Portrait_Release_Agreement_Popup_Content')}</div>
        <div className={cx('portrait-release-agreement-popup-content__agreement-action')}>
          <Form.CheckboxField
            name='portrait-release-agreement-checkbox'
            className={cx('portrait-release-agreement-popup-content__checkbox')}
            label={
              <div className={cx('portrait-release-agreement-popup-content__portrait-release-agreement-checkbox')}>
                {t('LiveRoom_Portrait_Release_Agreement_Popup_Agree')}
              </div>
            }
          />
        </div>
      </div>

      <div className={cx('portrait-release-agreement-popup-content__action-button')}>
        <Button size='md' isOutline onClick={handleClosePopup}>
          {t('LiveRoom_CheckPopup_Cancel')}
        </Button>
        <Button size='md' onClick={handleAgree} disabled={!values['portrait-release-agreement-checkbox']}>
          {t('LiveRoom_CheckPopup_Confirm')}
        </Button>
      </div>
    </div>
  )
}

export default PortraitReleaseAgreementPopupContentForm
